<div *ngIf="dataList?.length == 0 || dataList == null" style="display: flex;justify-content: space-between;align-items: center;">
    <div *ngIf="dataList?.length == 0 || dataList == null" class="text-center">
        No {{this.module == 'Opportunity' ? 'opportunity' : 'cases'}} found
    </div>
    <ng-container *ngIf="filteredAccount.statusId !== 2">
        <!-- <pre>{{dataList | json}}</pre> -->
        <div *ngIf="writePermission">
            <span class="btnBars" style="float: right;margin-right: 25px;" (click)="showAddPopup()">
                <i class="pi pi-plus"></i>
            </span>
        </div>
    </ng-container>
</div>

<ng-container *ngFor="let arr of dataList; let i = index;">
    <h6>{{arr.name}}<span class="p-ml-1">({{this.module == 'Opportunity' ? arr.numberOfOpportunities : arr.numberOfTickets}})</span>&nbsp;<span></span>
        <ng-container *ngIf="filteredAccount.statusId !== 2">
            <span class="btnBars" *ngIf="i==0" style="float: right;margin-right: 25px;" (click)="showAddPopup()">
                <i class="pi pi-plus"></i>
            </span>
        </ng-container>
    </h6>
    <p-table *ngIf="module == 'Opportunity'" [value]="arr?.opportunities" responsiveLayout="scroll"
        [(selection)]="selectedData" dataKey="id" (onRowSelect)="onRowSelect($event)">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: auto;">Opportunity Name</th>
                <th style="width: 150px;">Channel Name</th>
                <th style="width: 150px;">Closed Date</th>
                <th style="width: 150px;">Source</th>
                <th style="width: 150px;">Contact Name</th>
                <th style="width: 150px;">Total Amount</th>
                <th style="width: 150px; min-width: 150px;text-align:right">Action</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData">
                <td style="width: auto;"><span class="hyper-link" (click)="moduleNavigation(rowData)"> {{rowData?.name}}</span></td>
                <td style="width: 150px;">{{rowData?.channelName}}</td>
                <td style="width: 150px;">{{(rowData?.closedDate | localDate:'MM/DD/YYYY')}}</td>
                <td style="width: 150px;">{{rowData?.source}}</td>
                <td style="width: 150px;">{{rowData?.contactName}}</td>
                <td style="width: 150px;">{{(rowData?.totalAmount | number:'1.2-2' | currencySymbol)}}</td>
                <td class="action" style="width: 150px; min-width: 150px;text-align:right">
                    <ng-container *ngIf="filteredAccount.statusId !== 2">
                    <span *ngIf="editPermission" class="btnBars p-mr-0" pTooltip="{{'Edit'}}" (click)="openViewEdit(rowData,'update')">
                        <i class="pi pi-pencil"></i>
                    </span>
                </ng-container>
                    <span  class="btnBars p-mr-0" pTooltip="{{'View'}}" (click)="openViewEdit(rowData,'view')">
                        <i class="pi pi-eye"></i>
                    </span>
                    <ng-container *ngIf="filteredAccount.statusId !== 2">
                        <span pTooltip="{{'Delete'}}" *ngIf="deletePermission" class="btnBars p-mr-0"
                            (click)="deleteData(rowData)">
                            <i class="pi pi-trash"></i>
                        </span>
                    </ng-container>
                    <ng-container *ngIf="filteredAccount.statusId !== 2">
                        <span class="btnBars p-mr-0" (click)="openStagePopUp(rowData,i)" pTooltip="{{'Stage Change'}}" tooltipPosition="left">
                            <i class="pi pi-arrow-right"></i>
                        </span>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <p-table *ngIf="module == 'Case'" [value]="arr?.tickets" responsiveLayout="scroll" [(selection)]="selectedData" dataKey="id" (onRowSelect)="onRowSelect($event)">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 150px;">Case Association</th>
                <th style="width: 150px;">Channel Name</th>
                <th style="width: auto;">Case Details</th>
                <th style="width: 150px;">Association Name</th>
                <th style="width: 150px;">Contact Name</th>
                <th style="width: 150px;">Created Date</th>
                <th style="width: 150px; min-width: 150px;text-align:right">Action</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
            <tr [pSelectableRow]="rowData">
                <td style="width: 150px;">{{rowData?.caseAssociationName}}</td>
                <td style="width: 150px;">{{rowData?.channelName}}</td>
                <td style="width: auto;"><span class="hyper-link" (click)="moduleNavigation(rowData)" [pTooltip]="rowData?.caseDetail">{{ rowData?.caseDetail | shorten:100}}</span></td>
                <td style="width: 150px;">{{rowData?.associationName}}</td>
                <td style="width: 150px;">{{rowData?.contactName}}</td>
                <td style="width: 150px;">{{(rowData?.createdDate | localDate:'MM/DD/YYYY')}}</td>
                <td class="action" style="width: 150px; min-width: 150px;text-align:right">
                    <ng-container *ngIf="filteredAccount.statusId !== 2">
                        <span *ngIf="editPermission" class="btnBars p-mr-0" pTooltip="{{'Edit'}}" (click)="openViewEdit(rowData,'update')">
                            <i class="pi pi-pencil"></i>
                        </span>
                    </ng-container>
                    <span  class="btnBars p-mr-0" pTooltip="{{'View'}}" (click)="openViewEdit(rowData,'view')">
                        <i class="pi pi-eye"></i>
                    </span>
                    <ng-container *ngIf="filteredAccount.statusId !== 2">
                        <span pTooltip="{{'Delete'}}" *ngIf="deletePermission" class="btnBars p-mr-0"
                            (click)="deleteData(rowData)">
                            <i class="pi pi-trash"></i>
                        </span>
                    </ng-container>
                    <span *ngIf="filteredAccount.statusId !== 2" class="btnBars p-mr-0" (click)="openStagePopUp(rowData,i)" pTooltip="{{'Stage Change'}}" tooltipPosition="left">
                        <i class="pi pi-arrow-right"></i>
                    </span>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-divider class="y_padding" *ngIf="i !== dataList.length - 1"></p-divider>
</ng-container>

<!-- ----------------------------Add/Edit Opportunity---------------------- -->
<app-opportunity-add-edit-dialog *ngIf="displayAddEditView && module=='Opportunity'"
    [displayAddEditDialog]="displayAddEditView"
    [opportunityId]="opportunityEditViewId"
    [crudType]="crudType"
    [selectedAccount]="filteredAccount"
    [accountSelectionDisabled]="true"
    [opportunityChannelId]="opportunityChannelId"
    [accountChannelId]="selectedAccountChannel?.id"
    [opportunityChannelList]="opportunityChannelList"
    (reloadList)="updateParentOpportunity($event)"
    (closeModal)="closeDialog()">
</app-opportunity-add-edit-dialog>

<!-- Cases Add/Edit/View -->
<app-cases-add-edit-dialog *ngIf="displayAddEditView && module=='Case'" [displayAddEditDialog]="displayAddEditView"
    [casesId]="viewEditcaseId" [crudType]="crudType" [casesChannelId]="caseChannelId"
    [accountChannelId]="selectedAccountChannel.id" [groupUserList]="groupUserList" [callFromAccountTab]="true"
    [casesChannelList]="casesChannelList"
    [selectedAccount]="filteredAccount"
    (reloadList)="updateParentCases($event)" (closeModal)="closeDialog()">
</app-cases-add-edit-dialog>

<app-lion-comment-modal *ngIf="displayCommentAdd" [displayCommentAdd]="displayCommentAdd" [tempComment]="tempComment"
    [objectType]="objectType" [selectedCase]="selectedOpportunityDetail"
    [commentHeaderTitle]="commentHeaderName" [nextStageId]="nextStageIdForUpdate" [commentFormType]="commentFormType"
    [caseStagesAll]="stagesCountN" (commentSaved)="onCommentSaved($event)"
    (commentCancelClicked)="onCancelComment($event)" (commentDeleted)="onCommentDelete($event)">
</app-lion-comment-modal>
